<template>
  <div class="addBuyer">
    <!-- 添加买家 -->
    <md-popup v-model="ab_pop_show" :mask-closable="false">
      <md-popup-title-bar :title="ab_subData.id?'编辑买家':'新增买家'" :only-close="true" @cancel="closePop()"></md-popup-title-bar>
      <div class="pop_addBuyer">
        <div class="pop_addBuyer_box">
          <md-field>
            <md-field-item solid title="买家类型">
              <md-radio-group v-model="ab_subData.type">
                <md-radio-box name="1">个人</md-radio-box>
                <md-radio-box name="2">公司</md-radio-box>
              </md-radio-group>
            </md-field-item>
            <md-input-item title="买家姓名" clearable type="text" v-model="ab_subData.name" placeholder="请输入买家姓名"></md-input-item>
            <md-input-item
              title="联系电话"
              type="phone"
              clearable
              v-model="ab_subData.mobile"
              placeholder="请输入买家联系电话"
            ></md-input-item>
            <md-input-item title="车牌号码" type="text" v-model="ab_subData.car_no" clearable></md-input-item>
            <md-input-item title="备注" v-model="ab_subData.remark" clearable></md-input-item>
          </md-field>
          <div class="pop_addBuyer_btns">
            <md-button type="warning" plain size="small" inline @click="closePop()">取消</md-button>
            <md-button type="primary" size="small" inline @click="submitData">保存</md-button>
          </div>
        </div>
      </div>
    </md-popup>

  </div>
</template>

<script>
import { buyer_create ,buyer_detail} from "@/api/work/open";
import { isEmpty, isMobile  } from "@/utils/validate";
export default {
  name: 'addBuyer',
  data(){
    return {
      /**
       * 新增买家模块的变量 ab_ 开头 addbuyer
       */
      ab_pop_show:this.pop_show,
      loading:true,
      ab_subData: {
        id:this.buyer_id,
        type:"1",
        name: "",
        mobile: "",
        car_no: "",
        remark: ""
      },
    }
  },
  props:{
    pop_show: {
      type: Boolean,
      default: false
    },
    buyer_id: {
      type: [String,Number],
      default: ""
    },
  },
  watch: {
    pop_show: {
      handler(newValue, oldValue){ 
        this.ab_pop_show = newValue 
      },
      deep:true
    },
    buyer_id: {
      handler(newValue, oldValue){ 
        if(newValue){
          this.getDetail(newValue)
          this.ab_subData.id = newValue
        }else{
          this.ab_subData.id = ""
        }
      },
      deep:true
    },
  },
  created(){
    if(this.ab_subData.id){
      this.getDetail(this.ab_subData.id)  
    }
  },
  mounted(){




  },
  methods:{
    // 显示弹窗
    showPop(id){
      if(id){
        this.getDetail(id)
        this.ab_subData.id = id
      }else{
        this.ab_subData.id = ""
      }
      this.ab_pop_show = true
    },

    // 关闭弹窗
    closePop(type){
      // type == 1 完成 2 == 取消
      this.ab_pop_show = false
      setTimeout(()=>{
        this.ab_subData = {
          id:'',
          type:"1",
          name: "",
          mobile: "",
          car_no: "",
          remark: ""
        }
      },100)
      this.$emit("cancel",type?type:2);
      this.$emit("finish")
    },
    // 提交数据
    submitData(){ 
      if(!this.loading){
        return false
      }
      if(!this.ab_subData.name){ this.$toast.info("请输入买家姓名！"); return false }
      if(!isMobile(this.ab_subData.mobile)){ this.$toast.info("请输入正确的手机号码！"); return false }
      this.loading = false
      buyer_create(this.ab_subData).then(res=>{
        this.loading = true
        this.$toast.succeed(res.message)
        this.closePop("1")
      }).catch(err=>{
        this.loading = true
      })
    },

    getDetail(id){
      buyer_detail({id}).then(res=>{
        if(res.code == 200 ){
          this.ab_subData.name = res.data.name
          this.ab_subData.mobile = res.data.mobile
          this.ab_subData.car_no = res.data.car_no
          this.ab_subData.remark = res.data.remark
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.addBuyer{
  position: relative;
  // 添加买家模块
  .pop_addBuyer {
    width: 7rem;
    background-color: #fff;
    border-radius: 0 0 0.08rem 0.08rem;
    overflow: hidden;
    padding: 0 0.2rem;
    .pop_addBuyer_box {
      padding: 0 0 0.2rem 0;
      border-top: 0.01rem solid #e1e1e1;
    }
    .pop_addBuyer_btns{
      padding: 0.2rem 0.7rem 0.1rem;
      display: flex;
      align-items: center;
      justify-content: space-around;
    }
  }
}
</style>